import { Component, OnInit } from '@angular/core';
import { DzongkhaService } from '../../../services/dzongkha.service';
import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../../../services/utils.service';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-dzongkha-view',
  templateUrl: './dzongkha-view.component.html',
  styleUrls: ['./dzongkha-view.component.scss']
})

export class DzongkhaViewComponent implements OnInit {

  modelChanged: Subject<string> = new Subject<string>();

  dzongkha = {
    dzongkha: '',
    english: '',
    id: ''
  };

  constructor(private graphqlService: DzongkhaService,
              private snackBar: MatSnackBar,
              private router: Router,
              private route: ActivatedRoute,
              private utilsService: UtilsService) {
    //noinspection TypeScriptUnresolvedFunction
    this.modelChanged.debounceTime(1500).subscribe(model => this.updateDzongkha());

    route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];
        this.dzongkha.id = id;
        this.graphqlService.read(id).subscribe(result => {
          if (result && result.data) {
            this.dzongkha = JSON.parse(JSON.stringify(result.data['dzongkha']));
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });
      }
    });
  }


  ngOnInit() {
    const that = this;
    $('#body').on('tbwchange', function () {
      that.dataChanged();
    });
  }

  dataChanged() {
    this.modelChanged.next();
  }

  updateDzongkha() {
    const that = this;
    that.openSnackBar('Dzongkha updating!', '');
    that.graphqlService.update(that.dzongkha).subscribe(res => {
      console.log(res)
      if (res.data.updateDzongkha.success) {
        that.openSnackBar('Dzongkha updated!', '');
      }
    });
  }

  openSnackBar(message: string, action: string) {
    //noinspection TypeScriptValidateTypes
    this.snackBar.open(message, action, {duration: 3000});
  }

  deleteDzongkha() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.openSnackBar('Deleting Dzongkha!', '');
    this.graphqlService.delete(this.dzongkha).subscribe(res => {
      if (res.data.removeDzongkha.success) {
        this.openSnackBar('Dzongkha Deleted!', '');
        this.router.navigate(['/dzongkhas']);
      }
    }, err => {
      this.utilsService.openSnackBar('Unable to delete dzongkha.', '');
      console.log('there was an error sending the query', err);
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/dzongkha/dzongkha-view/dzongkha-view.component.ts